import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const ExplainTextSchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  text: z.string().min(1, 'Text to explain cannot be empty.'),
});

export type IExplainTextDto = z.infer<typeof ExplainTextSchema>;
